<template>
  <div>
    <el-table
      v-loading="loading"
      :data="items"
      size="small"
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        label="Title"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        prop="items_count"
        label="Fingerprints count (IP/UA)"
        align="center"
        :formatter="formatter"
      />
      <el-table-column
        prop="expiration_days"
        label="Days to Fingerprint expiration"
        align="center"
        :formatter="formatter"
      />
      <el-table-column align="center" label="Actions" prop="action">
        <template #default="{ row }">
          <el-tooltip class="item" placement="top-start" content="Edit list">
            <el-button
              type="success"
              size="small"
              circle
              plain
              icon="EditElementIcon"
              @click="edit(row)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="editModalVisible"
      :title="`Edit retargeting list ${currentItem.attributes?.title}`"
    >
      <RetargetingListForm
        v-if="currentItem.attributes"
        :id="currentItem.id || 0"
        ref="formRef"
        v-model="currentItem.attributes.expiration_days"
        @close="editModalVisible = false"
      />
      <template #footer>
        <el-button @click="editModalVisible = false">Cancel</el-button>
        <el-button type="primary" @click="formRef?.save()">Save</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import formatter from '@/utils/table'
import RetargetingListForm from './RetargetingListForm.vue'

export default defineComponent({
  name: 'ItemsTable',
  components: {
    RetargetingListForm
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const currentItem = ref({})
    const formRef = ref()
    const editModalVisible = ref(false)
    const edit = (row: any) => {
      currentItem.value = row
      editModalVisible.value = true
    }
    return {
      formatter,
      currentItem,
      edit,
      editModalVisible,
      formRef
    }
  }
})
</script>
